<div class="d-flex flex-column gap-2">
  <p-message
    severity="error"
    class="mt-1">
    {{ 'fe.globals.errors.scope_value_used_in_roles.cannot_be_deleted_because_it_is_used_in_the_following_roles' | translate }}
  </p-message>

  @for (panel of panels(); track panel.value; let last = $last) {
    <div class="d-flex flex-column gap-2">
      @if (panel.label) {
        <span class="slnk-md-medium">{{ panel.label }}</span>
      }
      <div class="d-flex flex-wrap gap-1">
        @for (role of panel.roles; track role.uuid) {
          <slnk-common-scope-value-role-item
            [role]="role"
            [canManageRoles]="canManageRoles()" />
        }
      </div>
    </div>
    @if (!last) {
      <p-divider />
    }
  }
</div>
